import VueRouter from 'vue-router'

let routes = [
  {
    path: '/',
    component:  resolve => require(['./app/Home.vue'], resolve),
    name: 'Home',
    meta: { title: 'Home' }
  },
  //USUÁRIOS
  {
    path: '/usuarios/pag=:page?/filtro=:filter?',
    component: resolve => require(['./app/Usuarios/Usuarios.vue'], resolve),
    name: 'Usuarios',
    meta: { title: 'Usuários' }
  },
  {
    path: '/usuario/:id/editar',
    component: resolve => require(['./app/Usuarios/EditarUsuario.vue'], resolve),
    name: 'EditarUsuario'
  },
  {
    path: '/usuario/buscar',
    component: resolve => require(['./app/Usuarios/BuscarUsuario.vue'], resolve),
    name: 'BuscarUsuario',
    meta: { title: 'Buscar' }
  },
  {
    path: '/pagamentos/pag=:page',
    component: resolve => require(['./app/Financeiro/Pagamentos.vue'], resolve),
    name: 'Pagamentos',
    meta: { title: 'Pagamentos' }
  },
  //Contato com o cliente
  {
    path: '/contato-com-cliente/pag=:page',
    component: resolve => require(['./app/Avisos/ContatoComCliente.vue'], resolve),
    name: 'Contato',
    meta: { title: 'Contato' }
  },
  // AVISOS - Alerta no sistema
  {
    path: '/avisos',
    component: resolve => require(['./app/Avisos/Avisos.vue'], resolve),
    name: 'Avisos'
  },
  //TESTES
 {
   path: '/testes',
   component: resolve => require(['./app/Testes/Testes.vue'], resolve),
   name: 'Testes',
   meta: { title: 'Testes' }
 },
 {
   path: '/teste/:id',
   component: resolve => require(['./app/Testes/VerTeste.vue'], resolve),
   name: 'VerTeste'
 },
 {
   path: '/teste/cadastrar',
   component:  resolve => require(['./app/Testes/CriarTeste.vue'], resolve),
   name: 'CriarTeste'
 },
 {
   path: '/teste/:id/editar',
   component:  resolve => require(['./app/Testes/EditarTeste.vue'], resolve),
   name: 'EditarTeste'
 },
]

export default new VueRouter({
  routes
})
